import { render, staticRenderFns } from "./featured-products-grid.vue?vue&type=template&id=537707bd"
import script from "./featured-products-grid.vue?vue&type=script&lang=js"
export * from "./featured-products-grid.vue?vue&type=script&lang=js"
import style0 from "./featured-products-grid.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsFeaturedProductCard: require('/home/node/app/components/patterns/featured-product-card/featured-product-card.vue').default,PatternsUiCta: require('/home/node/app/components/patterns/ui-cta/ui-cta.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default})
